export { BetaIcon } from "./beta-icon";
